import { Module } from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';
import { StateInterface } from '@/interfaces/projects';
import { SampleDetails } from '@/interfaces/samples';


const sampleDetailsModule: Module<SampleDetails, StateInterface> = {
    namespaced: true,
    actions,
    getters,
    mutations,
    state
}


export default sampleDetailsModule;